<template lang="html">
<div class="pgInner adsMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>需求定制</span>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入关键字" v-model="listParams.keyword" @input="reInxList">
                    <el-button @click="reInxList" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             @selection-change="tabSelect"
             v-loading="loading"
             style="width: 100%">

             <el-table-column
               prop="demandContext"
               label="需求描述">
             </el-table-column>

             <el-table-column
               prop="demandType"
               align="center"
               width="120"
               label="需求类型">
             </el-table-column>

             <el-table-column
               prop="userName"
               align="center"
               width="120"
               label="发布者">
             </el-table-column>

             <el-table-column
               prop="enterpriseName"
               align="center"
               width="120"
               label="所属企业">
             </el-table-column>

             <el-table-column
               prop="createdAt"
               align="center"
               width="180"
               label="发布时间">
             </el-table-column>

             <el-table-column
               width="180"
               align="center"
               label="操作">
               <template slot-scope="scope">

                   <div class="ibtn">
                     <span @click="goEdit(scope.row)">定制筛选</span>
                     <div class="dvLine"></div>
                   </div>
                   <div class="ibtn">
                     <span @click="goRemove(scope.row)">删除</span>
                     <div class="dvLine"></div>
                   </div>

               </template>
             </el-table-column>


          </el-table>

          <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-count="allPages"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { requireList,requireRemove } from "@/api/enterprise/index";
export default {
    computed:{
      lineStr:function(){
          var str = "left:" + this.navX + "px;";
          return str;
      }
    },
    filters:{

    },
    data(){
        return{
            pageH:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,

            listParams:{
               keyword:'',
               statusList:'',
               no:1,
               size:20
            },

            allPages:0,
            allEls:0,

            options:[
               { key:1,name:'未认证' },
               { key:2,name:'已认证' },
               { key:4,name:'审核失败' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        transCode:function(e,type){

        },
        getList:function(){
            this.loading = true;
            requireList(this.listParams).then(res => {
                this.listData = res.myDemandCustomizationList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        selectChange:function(e){
            this.listParams[e.paramsKey] = e.id;
            this.reInxList();
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            this.$confirm('确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                requireRemove({ids:[e.id]}).then(res => {
                    vues.reInxList();
                })
            })
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                statusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                });
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goEdit:function(e){   // 编辑
            this.$router.push({
                path:'require_edit',
                query: {
                    id:e.id
                }
            });
        },

        tabSelect:function(e,type){
            var arrs = [];
            if(type == 1){
                arrs = [e.id];
                this.selectArr = arrs;
                this.goRemove();
            }else{
                e.forEach(item => {
                    arrs.push(item.id);
                })
                this.selectArr = arrs;
            }
        },

        handleCurrentChange:function(e){
            this.listParams.no = e;
            this.getList();
        },
        reInxList:function(){
            this.listParams.no = 1;
            this.getList();
        },
        goFrash:function(){
            this.$emit('go-frash');
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();
            this.typeIdSet();


        },
    },
    created:function(){

        this.pageFix();
        this.getList();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns{
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.exLine{
   padding: 9px 0px;
   position: relative;

   .iName{
       width: 80px;
       float: left;
   }

   .iContent{
       margin-left: 80px;
       color: #999999;
   }
}

.pocLine{
    margin-top: 9px;
}

.pgbody{
  margin: 20px;
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.adsMessage .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.adsMessage .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>



// WEBPACK FOOTER //
// requireList.vue?7f0bd48b